import React from 'react';
import {
  Box,
  Stack,
  Typography,
  styled,
  Link,
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const StackColumn = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flex: 1,
  gap: theme.spacing(2),
  textAlign: 'center',
}));

const BoxRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  background: '#c1c5c6', // Azul marino suave
  color: '#0e1116', // Azul oscuro para los textos
  padding: theme.spacing(4, 2),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
}));

const FooterLink = styled(Link)(({ theme }) => ({
  color: '#0e1116',
  textDecoration: 'none',
  fontSize: '0.9rem',
  fontWeight: '400',
  '&:hover': {
    color: '#1565c0', // Azul más vibrante al pasar el cursor
  },
}));

const FooterTitle = styled(Typography)(({ theme }) => ({
  fontWeight: '700',
  fontSize: '1.2rem',
  marginBottom: theme.spacing(1),
  textTransform: 'uppercase',
  color: '#0e1116',
}));

/**
 * Footer with alternative medical colors
 */
const Footer = () => {
  return (
    <BoxRow component="footer">
      <StackColumn>
        <FooterTitle>Dirección (Con cita previa)</FooterTitle>
        <Typography variant="body2">Privada 4a Norte Oriente 2067</Typography>
        <Typography variant="body2">Entre 19 y 20 Ote.</Typography>
        <Typography variant="body2">Fracc. Santos</Typography>
      </StackColumn>

      <StackColumn>
        <FooterTitle>IMDI Tuxtla</FooterTitle>
        <Stack direction="row" spacing={2}>
        <FooterLink
          href="https://www.instagram.com/imdituxtla?igsh=dTJ1eDdqODAyN3Qy"
          target="_blank"
          rel="noopener noreferrer"
        >
          <InstagramIcon fontSize="large" />
        </FooterLink>
        <FooterLink
          href="https://api.whatsapp.com/send?phone=5219612283232&text=¡Hola!, necesito ayuda"
          target="_blank"
          rel="noopener noreferrer"
        >
          <WhatsAppIcon fontSize="large" />
        </FooterLink>
        <FooterLink
          href="https://www.facebook.com/imditux"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FacebookIcon fontSize="large" />
        </FooterLink>
        </Stack>
        <Typography variant="body2">&copy; 2025 IMDI Tuxtla.</Typography>
      </StackColumn>
    </BoxRow>
  );
};

export default Footer;